import * as React from 'react';
import { connect } from 'react-redux';
import { SurveyBasics } from '../../components/pages/SurveyBasics';
import { SurveyStep } from '../../models';
import { ActionCreators as BenchmarksActionCreators } from '../../store/BenchmarksStore';
import { ActionCreators as CulturesActionCreators } from '../../store/CulturesStore';
import { IApplicationState } from '../../store/index';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';
import { ActionCreators as TextToSpeechCultureActionCreators } from '../../store/TextToSpeechCultureStore';
import { UserHelper } from '../../utilities';
import { SurveyPageStateSetter } from '../state-setter/SurveyPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const SurveyBasicsContainer: React.ComponentType<any> = connect(
	(state: IApplicationState) => ({
		...state.cultures,
		...state.benchmarks,
		...state.survey,
		...state.surveyBuilder,
		...state.textToSpeechCultures,
		...state.externalHierarchy,
		clientId: UserHelper.getNumberFromUserProfile(state.oidc.user, 'external_clientid'),
		userType: state.oidc.user?.profile.userType,
	}),
	{
		...CulturesActionCreators,
		...SurveyBuilderActionCreators,
		...SurveyActionCreators,
		...BenchmarksActionCreators,
		...TextToSpeechCultureActionCreators,
	},
)(SurveyBasics);

export class SurveyBasicsPage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<SurveyBasicsContainer {...this.props} />
				<SurveyPageStateSetter {...this.props} currentStep={SurveyStep.Basics} />
			</>
		);
	}
}
